import { HttpService } from '../HttpService/HttpService';


export class OperationLogService {
    constructor( private httpService: HttpService) {
       
    }   
    getAuditReport = (params:any) => {
        return this.httpService.get('/report/audit-report', {  ...params });
    };

    downloadAuditReport = (params:any) => {
        return this.httpService.get('/report/download-audit-report', {  ...params });
    }
}
